import { Link } from 'react-router-dom'

import { exitImpersonate } from '../apis/common.apis'
import Icons from '../components/common/icons'
import { useSnackbarManager } from '../components/common/snackbar'
import { useAuthStore } from '../store/authStore'
import { useDomainManageStore } from '../store/domainManageStore'
import { useAccreditationFilterStore } from '../store/filterSore/accreditationStore'
import { useAdminUserFilterStore } from '../store/filterSore/adminUserStore'
import { useAssessorFilterStore } from '../store/filterSore/assessorStore'
import { useClearFilter } from '../store/filterSore/clearStore'
import { useOrganisationFilterStore } from '../store/filterSore/OrganisationStore'
import { useLayoutStore } from '../store/layoutStore'
import HeaderMenu from './headerMenu'
import HeaderTab from './headerTab'

const HeaderTop = () => {
  const { layoutType, expand, setExpand, expandMenu, setExpandMenu } =
    useLayoutStore()
  const handleClear = useClearFilter()

  const {
    clearAuthenticated,
    userData,
    impersonating,
    setImpersonating,
    setActualUser,
    setUserData,
    actualeUser,
    setToken,
    adminToken,
    setAdminToken,
    setActiveRow,
    setAssessorImpersonating,
    setOrgImpersonating,
    adminImpersonating,
    orgImpersonating,
    assessorImpersonating,
    setImpersonatorId,
  } = useAuthStore()

  const { enqueueSnackbar } = useSnackbarManager()

  const handleStopImpersonating = async () => {
    useAdminUserFilterStore.getState().resetStore()
    useAssessorFilterStore.getState().resetStore()
    useOrganisationFilterStore.getState().resetStore()
    useAccreditationFilterStore.getState().resetStore()
    setImpersonatorId('')

    try {
      if (domainType !== 'Employee') {
        const res = await exitImpersonate()
        setImpersonating(false)
        domainType === 'Organisation' && setOrgImpersonating(false)
        domainType === 'Assessor' && setAssessorImpersonating(false)
        // localStorage.removeItem('authenticated')
        localStorage.clear()
        localStorage.setItem('shouldReload', 'true')

        // const url = `${res}?exit&type=${encodeURIComponent(domainType)}`
        // console.log('url', url)
        window.open(res, '_self')
      } else {
        setToken(adminToken as string)
        setUserData({
          ...actualeUser,
        })
        setDomainType('Employee')
        setAdminToken('')
        setActiveRow({})
        setImpersonating(false)
        localStorage.setItem('shouldReload', 'true')
      }
    } catch (err: any) {
      enqueueSnackbar('Exit action filed ', { variant: 'error' })
    }
  }
  const getStatus = () => {
    if (domainType === 'Employee' && impersonating && adminImpersonating) {
      return true
    }
    if (domainType === 'Assessor' && impersonating && assessorImpersonating) {
      return true
    }
    if (domainType === 'Organisation' && impersonating && orgImpersonating) {
      return true
    }
    return false
  }

  const handleLogout = () => {
    useAdminUserFilterStore.getState().resetStore()
    useAssessorFilterStore.getState().resetStore()
    useOrganisationFilterStore.getState().resetStore()
    useAccreditationFilterStore.getState().resetStore()

    if (getStatus()) {
      handleStopImpersonating()
    } else {
      setActualUser({})
      setImpersonating(false)
      localStorage.clear()
      handleClear()
      localStorage.setItem('shouldReload', 'false')
      clearAuthenticated()
    }
  }
  const { domainType, setDomainType } = useDomainManageStore()
  const handleReturnPath = () => {
    if (domainType === 'Organisation') {
      return '/myorganisation/profile'
    } else if (domainType === 'Assessor') {
      return '/assessors'
    } else {
      return '/admin-user'
    }
  }

  return (
    <>
      {getStatus() && (
        <div className="fixed top-0 left-0 w-full bg-primary text-white text-center py-3 z-40">
          <p className="text-lg">
            {`You are impersonating ${userData?.name}   `}
            <span
              className="underline cursor-pointer ml-5"
              onClick={handleStopImpersonating}
            >
              Exit Now
            </span>
          </p>
        </div>
      )}
      <div
        className={`h-[64px] fixed w-full top-0 left-0 z-30 flex items-center justify-between bg-white border-formBorder border-b pe-5 ${
          impersonating && 'mt-12'
        }`}
      >
        <div className="w-[175px] ps-5 flex justify-between">
          <Link to={handleReturnPath()}>
            <div className="flex items-center gap-2 w-[135px]">
              <img className=" h-9" src="/images/logo-horizontal-new.png" />
            </div>
          </Link>

          {layoutType === 'sideNav' ? (
            <div
              onClick={() => setExpand(!expand)}
              className="h-6 w-6 fill-grey-medium cursor-pointer"
            >
              <Icons name="menu" />
            </div>
          ) : (
            ''
          )}
        </div>
        {layoutType === 'headerNav' && <HeaderTab />}
        <div className="flex gap-3">
          <div className="flex gap-2 items-center">
            <HeaderMenu userData={userData} handleLogout={handleLogout} />
          </div>
          {layoutType === 'headerNav' ? (
            <div
              onClick={() => setExpandMenu(!expandMenu)}
              className="size-8 text-grey-medium border border-grey-mediumAlt p-1  rounded-xs cursor-pointer lg:hidden"
            >
              <Icons name="hamburger" />
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    </>
  )
}

export default HeaderTop
